import React from "react";
import { inject, observer } from "mobx-react";
import { OverlayTrigger, Glyphicon, Popover } from "react-bootstrap";

@inject("searchStore")
@observer
export class CustomTooltip extends React.Component {
  getTooltipContent = () => {
    const { searchStore, type } = this.props;
    const content = searchStore.getSDDBusinessContent(type);
    return content && content.description ? <p>{content.description}</p> : null;
  };

  render() {
    const content = this.props.content
      ? this.props.content
      : this.getTooltipContent();
    const placement = this.props.placement || "right";
    const color = this.props.color || "";

    const popoverRight = <Popover id={this.props.type}>{content}</Popover>;

    return (
      <div
        className="custom-tooltip"
        style={{ display: content ? "flex" : "none", color: color }}
      >
        <OverlayTrigger overlay={popoverRight} placement={placement} rootClose>
          <span>
            <Glyphicon glyph="info-sign" />
          </span>
        </OverlayTrigger>
      </div>
    );
  }
}
